import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

// ----------------------------------------------------------------------

export const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll window
    window.scrollTo({ top: 0 })
    // Scroll HTML element too
    document.documentElement.scrollTo({ top: 0 })

    // Some Android builds scroll body instead of html
    document.body.scrollTo({ top: 0 })
  }, [pathname])

  return null
}
